import {
    action,
    extendObservable,
    // toJS
} from 'mobx';
import { TIMEOUT_DELAY } from '../helpers/constants';
import { FETCH_ERROR_TITLE, FETCH_ERROR_MSG } from '../helpers/messageText';
import store from './store';

export default class AlertStore {
    constructor(factory) {
        this.factory = factory;  
        this.history = null;   
        extendObservable(this, {
            show: false,
            cancelFunction: () => {
                this.hideAlert();
            },
            submitFunction: () => {
                alert('submit');
            },
            heading: 'ModalPopup heading',
            message: 'ModalPopup message',
            submitLabel: 'Submit',
            cancelLable: 'Cancel',
            timer: 0,
            timerCounter: TIMEOUT_DELAY / 1000,

            /******************************************************************************
            Standard Alert methods
            ******************************************************************************/
            setAlert: action(
                'setAlert',
                (submitFunction, cancelFunction, heading, message, submitLabel, cancelLable, props) => {
                    this.cancelFunction = cancelFunction;
                    this.submitFunction = submitFunction;
                    this.heading = heading;
                    this.message = message;
                    this.submitLabel = submitLabel;
                    this.cancelLable = cancelLable;

                    //setting the params, will also show the alert
                    this.show = true;
                   // this.history = props.history;
                },
            ),

            showAlert: action('showAlert', () => {
                this.show = true;
            }),

            hideAlert: action('hideAlert', () => {
                // console.log("hiding alert");
                this.show = false;
            }),

            defaultOfflineAlert: async () => {
                if (!await store.conn.checkOnlineStatus()) {
                    this.factory.alert.setAlert(
                        this.factory.alert.hideAlert,
                        this.factory.alert.hideAlert,
                        FETCH_ERROR_TITLE,
                        FETCH_ERROR_MSG,
                        'OK',
                        '',
                    );
                    return false;
                }
                return true;
            },

            /******************************************************************************
            Timer methods - used by the inactivity timeout functionality (App.js)
            ******************************************************************************/
            startTimer: action('startTimer', () => {
                this.timer = setInterval(this.countDown, 1000);
            }),

            countDown: action('countDown', () => {
                if (this.timerCounter === 0) {
                    this.hideAlert();
                    this.clearTimer();

                    if (window.offlineApiExtension) {
                        store.user.askForPin();
                    } else {                      
                        store.user.logout();
                       // store.user.logout(this.history);
                    }
                } else {
                    this.timerCounter -= 1;
                }
            }),

            clearTimer: action('clearTimer', () => {
                if (this.timer !== 0) {
                    clearInterval(this.timer);
                }
                this.timer = 0;
                this.timerCounter = TIMEOUT_DELAY / 1000;
            }),
        });
    }
}



// WEBPACK FOOTER //
// ./src/stores/AlertStore.js